// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_wrapper__2GOUc"};